import React, {Suspense, useCallback, useContext, useEffect} from "react"
import {BrowserRouter as Router, Routes} from "react-router-dom"

import Box from "@mui/material/Box"

import "./App.css"
import "./Styles.css"
import "./styles/global.css"
import moment from "moment-timezone"
import {SnackbarProvider} from "notistack"

import AuthKeycloak from "@auth/components/AuthKeycloak"
import {useKeycloakLogout} from "@auth/hooks/useKeycloakLogout"
import {isAuthCallbackUrl} from "@auth/utils/token"

import {DocoonBroaCastChanel} from "@components/common/BoradCastChanel"
import NdToast from "@components/common/NdComponents/NdToast"
import Sidebar from "@components/layout/SideMenu/SideMenu"

import ErrorContext from "./context/ErrorContext"
import CommonUtils from "./utils/Common"
import Loader from "./utils/Loader"
import Routing from "./utils/Routing"

function App() {
    const context = useContext(ErrorContext)
    const location = window.location.href
    const {logout} = useKeycloakLogout()

    const isRolled = useCallback(() => CommonUtils.ToBoolean(CommonUtils.GetLocal("isRoleSelected")), [])

    const resetLocalStorage = useCallback(() => {
        if (isAuthCallbackUrl()) {
            return
        }

        if (!isRolled() && CommonUtils.rightPath(location)) {
            CommonUtils.resetLocalStorage()
        }
    }, [isRolled, location])

    const handleBroadcastMessage = useCallback(async () => {
        try {
            const msg = await DocoonBroaCastChanel()

            switch (msg) {
                case "logout":
                    context.setGlobalLoading(true)
                    logout()
                    break
                case "changerole":
                case "Refreshe":
                    context.setGlobalLoading(true)
                    CommonUtils.goHome()
                    break
                default:
                    console.warn("Unknown message on the docoon channel:", msg)
            }
        } catch (error) {
            console.error("Error handling broadcast message:", error)
        }
    }, [context])

    useEffect(() => {
        moment.tz.setDefault("Europe/Paris")
        handleBroadcastMessage()
        resetLocalStorage()
    }, [handleBroadcastMessage, resetLocalStorage])

    return (
        <SnackbarProvider
            anchorOrigin={{
                horizontal: "right",
                vertical: "top"
            }}
            autoHideDuration={10000}
            Components={{
                default: NdToast
            }}
            maxSnack={6}
        >
            <Router>
                <AuthKeycloak>
                    <Box sx={{display: "flex"}}>
                        {!context.globalLoading && <Sidebar />}
                        <Suspense fallback={<Loader isLoading={true} />}>
                            <Routes>{Routing.CreateRouting()}</Routes>
                        </Suspense>
                    </Box>
                </AuthKeycloak>
            </Router>
        </SnackbarProvider>
    )
}

export default App
